import { Globals } from "../CoreApp/Globals";

export function handledosave2() {
  var w = Globals._wsMgr;
  var fileName = w["fileName"];
  var directory = w["directory"];
  var jbuffer = w["jbuffer"];
  w["jbuffer"] = null;

  w.DoUpload(jbuffer, fileName, directory);
}
